import { Button, AppBar, Toolbar } from "@material-ui/core";

import { UnsupportedChainIdError, useWeb3React } from "@web3-react/core";
import Logo from "../assets/Logo.svg";
import shortLogo from "../assets/shortLogo.svg";
import { Link } from "react-router-dom";
import React, { useCallback, useState } from "react";
import {
  InjectedConnector,
  NoEthereumProviderError,
  UserRejectedRequestError,
} from "@web3-react/injected-connector";
import { WalletConnectConnector } from "@web3-react/walletconnect-connector";
import { injected } from "../utils/web3Connectors";
import { walletconnect } from "../utils/web3ConnectFunctions";

import Modal from "@material-ui/core/Modal";
import SimpleModal from "./SimpleModal";
import { conciseAddress } from "../utils/formatters";
import { useStyles } from "../theme/styles/components/formHeaderStyles";

// const useStyles = makeStyles((theme) => ({
//   connectBtn: {
//     color: "#000",
//     width: 240,
//     height: 50,
//     fontWeight: "500",
//     fontSize: 18,
//     lineHeight: "10px",
//     textTransform: "capitalize",
//     marginRight: 10,
//   },

//   connectBtnContainer: {
//     marginBottom: 30,
//     display: "flex",
//     // alignItems: "center",

//     justifyContent: "space-between",
//     marginRight: 16,

//     [theme.breakpoints.down("sm")]: {
//       flexDirection: "column-reverse",
//       marginRight: 0,
//     },

//     [theme.breakpoints.down("xs")]: {
//       alignItems: "center",
//     },
//   },

//   connectWalletContainer: {
//     [theme.breakpoints.down("sm")]: {
//       marginBottom: 20,
//       justifyContent: "flex-end",
//       display: "flex",
//     },
//   },

//   modal: {
//     display: "flex",
//     // marginTop: "10%",
//     alignItems: "center",
//     justifyContent: "center",
//   },

//   info: {
//     fontSize: 14,
//     lineHeight: "20px",
//     color: "#000",
//     textAlign: "center",
//     [theme.breakpoints.up("xs")]: {
//       marginLeft: 10,
//     },
//     [theme.breakpoints.down("xs")]: {
//       marginTop: 10,
//     },
//   },

//   infoContainer: {
//     borderRadius: 10,
//     minHeight: 40,
//     padding: "0 30px",

//     [theme.breakpoints.down("sm")]: {
//       // flexDirection: "column",
//       // minHeight: 100,
//       width: "80%",
//       justifyContent: "center",
//       alignSelf: "center",
//     },

//     [theme.breakpoints.down("xs")]: {
//       flexDirection: "column",
//       width: "90%",
//       minHeight: 100,
//       justifyContent: "center",
//     },
//   },

//   connectedBtn: {
//     background: "#000",
//     borderRadius: "10px",

//     [theme.breakpoints.down("500")]: {
//       width: 200,
//     },

//     [theme.breakpoints.down("400")]: {
//       width: 170,
//       marginRight: 8,
//     },
//   },

//   connectedText: {
//     color: "#fff",
//     fontSize: 16,
//     lineHeight: "14px",
//     fontWeight: 400,
//   },

//   activeDot: {
//     background: "linear-gradient(180deg, #00E2FE 0%, #19FADD 100%)",
//     height: 20,
//     width: 20,
//     borderRadius: 100,
//     marginRight: 10,
//   },

//   networkBtn: {
//     height: 50,
//     background: "#000",
//     border: "1px solid rgba(255, 255, 255, 0.28)",
//     borderRadius: "10px",
//     marginRight: 15,
//     width: 90,

//     [theme.breakpoints.down("500")]: {
//       width: 90,
//     },

//     [theme.breakpoints.down("400")]: {
//       width: 80,
//       marginRight: 8,
//     },
//   },

//   networkImage: {
//     height: 20,
//     width: 20,
//     marginRight: 8,
//   },

//   InfoButton: {
//     padding: 0,
//     [theme.breakpoints.down("500")]: {},
//   },
// }));
function rand() {
  return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    // display: "flex",
    // justifyContent: "center",
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const FormHeader = () => {
  const web3context = useWeb3React();

  const classes = useStyles();

  const [modalStyle] = useState(getModalStyle);
  const [modal, setModal] = useState(false);

  const handleOpen = () => {
    setModal(true);
  };

  const handleClose = () => {
    setModal(false);
  };

  const body = (
    <div style={modalStyle} className={classes.paper}>
      <SimpleModal handleClose={handleClose} />
    </div>
  );

  const getErrorMessage = (e) => {
    if (e instanceof UnsupportedChainIdError) {
      return "Unsupported Network";
    } else if (e instanceof NoEthereumProviderError) {
      return "No Wallet Found";
    } else if (e instanceof UserRejectedRequestError) {
      return "Wallet Connection Rejected";
    } else if (e.code === -32002) {
      return "Wallet Connection Request Pending";
    } else {
      return "An Error Occurred";
    }
  };

  const activateWallet = useCallback(
    (connector, onClose = () => {}) => {
      if (
        connector instanceof WalletConnectConnector &&
        connector.walletConnectProvider?.wc?.uri
      ) {
        connector.walletConnectProvider = undefined;
      }

      web3context
        .activate(
          connector
            ? connector
            : new InjectedConnector({
                supportedChainIds: [1, 3, 4, 5, 42, 97, 56],
              }),
          undefined,
          true
        )
        .then(() => {})
        .catch((e) => {
          const err = getErrorMessage(e);

          console.error("ERROR activateWallet -> ", e);
          //   setLoadingF({ walletConnection: false });
        });
    },
    [web3context]
  );

  const deactivateWallet = async () => {
    await web3context.deactivate();
    console.log(web3context, "TEST", web3context.active);
    if (web3context?.connector instanceof WalletConnectConnector) {
      alert("insie");
      await web3context.connector.close();
    }
  };

  return (
    <>
      {/* <Box className={classes.connectBtnContainer}>
        <Box></Box>
        {!web3context.active && !web3context.account && (
          <Box
            display="flex"
            alignItems="center"
            className={classes.infoContainer}
          >
            <img src={WarningIcon} />
            <Typography className={classes.info}>
              Please connect your wallet to view your information
            </Typography>
          </Box>
        )}

        <Box className={classes.connectWalletContainer}>
          {web3context.active &&
          web3context.account &&
          (web3context.chainId === 4 ||
            web3context.chainId === 42 ||
            web3context.chainId === 1) ? (
            <Button className={classes.networkBtn}>
              <img src={EthereumIcon} className={classes.networkImage} />
              <Typography className={classes.connectedText}>ETH</Typography>
            </Button>
          ) : web3context.chainId === 97 || web3context.chainId === 56 ? (
            <Button className={classes.networkBtn}>
              <img src={BinanceIcon} className={classes.networkImage} />
              <Typography className={classes.connectedText}>BNB</Typography>
            </Button>
          ) : null}
          <Button
            variant={
              web3context.active && web3context.account
                ? "outlined"
                : "contained"
            }
            startIcon={
              !web3context.active && !web3context.account && <AddIcon />
            }
            onClick={() => setModal(true)}
            className={[
              classes.connectBtn,
              web3context.account && classes.connectedBtn,
            ]}
          >
            {web3context.active && web3context.account && (
              <div className={[classes.activeDot]}></div>
            )}
            <Typography
              className={[web3context.account && classes.connectedText]}
            >
              {web3context.active && web3context.account
                ? conciseAddress(web3context.account)
                : "CONNECT WALLET"}
            </Typography>
          </Button>

          <Button
            onClick={() => setHelpModal(true)}
            className={classes.InfoButton}
          >
            <img src={InfoIcon} />
          </Button>
        </Box>
      </Box>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={modal}
        onClose={() => setModal(false)}
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={modal}>
          <ConnectWalletModal onSuccess={() => setModal(false)} />
        </Fade>
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={helpModal}
        onClose={() => setHelpModal(false)}
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 100,
        }}
      >
        <Fade in={helpModal}>
          <HelpModal onSuccess={() => setHelpModal(false)} />
        </Fade>
      </Modal> */}
      <AppBar position="fixed" className={classes.header}>
        <Toolbar>
          {/* <Link className={classes.logo} to="/" style={{ flex: 1 }}>
            <img src={Logo} alt="noimage" />
          </Link> */}
          <Link className={classes.shortLogo} to="/" style={{ flex: 1 }}>
            <img src={shortLogo} alt="noimage" />
          </Link>

          <div className={classes.toolbarBtns}>
            <Button
              className={classes.walletButton}
              disabled={
                web3context.active &&
                web3context.account &&
                web3context?.connector instanceof WalletConnectConnector
              }
              onClick={() =>
                !web3context.active &&
                !(web3context?.connector instanceof InjectedConnector)
                  ? activateWallet(injected)
                  : deactivateWallet()
              }
            >
              {web3context.active && web3context.account
                ? conciseAddress(web3context.account)
                : "Connect Wallet"}
            </Button>
          </div>
        </Toolbar>
      </AppBar>

      {/* {web3context.active &&
        web3context.account &&
        web3context?.connector instanceof InjectedConnector ? (
          <Box>
            <Box style={{ marginBottom: 12 }}>
              <Typography>Wallet Address :</Typography>
              <Typography style={{ wordWrap: "break-word" }}>
                {web3context.account}
              </Typography>
            </Box>

            <Box style={{ marginBottom: 12 }}>
              <Typography>Chain Id :</Typography>
              <Typography>{web3context.chainId}</Typography>
            </Box>

            <Box style={{ marginBottom: 12 }}>
              <Typography>Network :</Typography>

              <Typography>
                {web3context.chainId === 4 ||
                web3context.chainId === 42 ||
                web3context.chainId === 1
                  ? "ETH"
                  : web3context.chainId === 97 || web3context.chainId === 56
                  ? "BNB"
                  : "-"}
              </Typography>
            </Box>
          </Box>
        ) : web3context.active && web3context.account ? (
          <Typography>Wallet Already Connected</Typography>
        ) : (
          <Typography>Please connect your wallet</Typography>
        )} */}

      {/* <Button
          variant="contained"
          color="primary"
          style={{ marginBottom: 12 }}
          disabled={
            web3context.active &&
            web3context.account &&
            web3context?.connector instanceof InjectedConnector
          }
          onClick={() => {
            !web3context.active &&
            !(web3context?.connector instanceof WalletConnectConnector)
              ? activateWallet(walletconnect)
              : deactivateWallet();
          }}
        >
          {web3context.active &&
          web3context.account &&
          web3context?.connector instanceof WalletConnectConnector
            ? "Disconnect TrustWallet"
            : "Connect TrustWallet"}
        </Button> */}

      {/* {web3context.active &&
        web3context.account &&
        web3context?.connector instanceof WalletConnectConnector ? (
          <Box>
            <Box style={{ marginBottom: 12 }}>
              <Typography>Wallet Address :</Typography>
              <Typography style={{ wordWrap: "break-word" }}>
                {web3context.account}
              </Typography>
            </Box>

            <Box style={{ marginBottom: 12 }}>
              <Typography>Chain Id :</Typography>
              <Typography>{web3context.chainId}</Typography>
            </Box>

            <Box style={{ marginBottom: 12 }}>
              <Typography>Network :</Typography>

              <Typography>
                {web3context.chainId === 4 ||
                web3context.chainId === 42 ||
                web3context.chainId === 1
                  ? "ETH"
                  : web3context.chainId === 97 || web3context.chainId === 56
                  ? "BNB"
                  : "-"}
              </Typography>
            </Box>
          </Box>
        ) : web3context.active && web3context.account ? (
          <Typography>Wallet Already Connected</Typography>
        ) : (
          <Typography>Please connect your wallet</Typography>
        )} */}
    </>
  );
};

export default FormHeader;
